import { Auth } from "@kinetics254/cassandra-base/modules/auth";
import AppDashboard from "@/packages/cassandra-base/app/layout/AppDashboard";
import OnlineTransaction from "./views/OnlineTransaction.vue";

export default [
    {
        path: "/online",
        component: AppDashboard,
        children: [
            {
                path: "",
                redirect: "/online/status",
            },
            {
                path: "status",
                name: "onlineTransactionStatus",
                components: {
                    view: OnlineTransaction,
                },
                meta: {
                    middleware: Auth,
                },
            },
        ],
    },
];
